import * as React from 'react';
import { Paper, Typography } from "@mui/material";
import Zoom from '@mui/material/Zoom';
import styles from "../css/gis.module.css"

export const PopupViewBit = ({ item }) => {
    const [transitionIn, setTransitionIn] = React.useState(false)


    // 오버플로우 상태를 추적할 ref와 state
    const nmRef = React.useRef(null);
    const idRef = React.useRef(null);
    const [nmOverflow, setNmOverflow] = React.useState(false);
    const [idOverflow, setIdOverflow] = React.useState(false);

    React.useEffect(() => {
        setTransitionIn(false);
        const key = setTimeout(() => {
          setTransitionIn(true);

    // DOM이 확실히 렌더링된 후 측정
    if (nmRef.current) {
        const nmEl = nmRef.current;
        const overflow = nmEl.scrollWidth > nmEl.clientWidth;
        console.log("nmRef", { scrollWidth: nmEl.scrollWidth, clientWidth: nmEl.clientWidth, overflow });
        setNmOverflow(overflow);
      }
      if (idRef.current) {
        const idEl = idRef.current;
        const overflow = idEl.scrollWidth > idEl.clientWidth;
        console.log("idRef", { scrollWidth: idEl.scrollWidth, clientWidth: idEl.clientWidth, overflow });
        setIdOverflow(overflow);
      }
    }, 400); // Zoom in 이후에 측정되도록 타이밍 확보
  
    return () => clearTimeout(key);
  }, [item.id, item.nm]);
  
    return (
        <Zoom in={transitionIn} timeout={300} easing={{ enter: "ease-out", exit: "ease-in" }}>
            <div className={`${styles.gisPopup_bit} gisPopup flx flx_col gap10`}>
                <div className='flx a_center'>
                  <div className='popTit'>BIT</div>
                  <div className={`${styles.flow_wrap_stop} flow_wrap`} ref={nmRef}>
                    <span className={`flow_txt ${nmOverflow ? "animate-delay" : ""}`}>{item.nm}</span>
                  </div>
                </div>
                <div className='flx gap20 j_spc_btw w_100'>
                  <div className='flx_col gap20'>
                    <div className='flx a_center'>
                      <div className='popTit'>상태</div>
                        {item.stat == 1 ? <div className='gr'>정상</div> : <div className='rd'>장애</div>}
                    </div>
                    <div className='flx a_center'>
                      <div className='popTit'>ID</div>
                      <div className='popTxt'>{item.id}</div>
                  </div>
                  </div>
                  <div style={{width:'40%'}}>
                    <img style={{width:'100%', height:'100%'}} src='/images/facility/bit.jpg'/>
                  </div>
                </div>

            </div>
        </Zoom>
    )
}